import { Component, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';

type Tab = 'orders' | 'subscriptions';

@Component({
  selector: 'app-orders-tabs',
  templateUrl: './orders-tabs.component.html',
  styleUrls: ['./orders-tabs.component.scss'],
})
export class OrdersTabsComponent implements OnInit, OnDestroy {
  activeTab: Tab = 'orders';
  private routerSub?: Subscription;

  constructor(private router: Router) {}

  ngOnInit(): void {
    this.activeTab = this.resolveTabFromUrl(this.router.url);
    this.routerSub = this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.activeTab = this.resolveTabFromUrl(event.urlAfterRedirects);
      });
  }

  ngOnDestroy(): void {
    this.routerSub?.unsubscribe();
  }

  selectTab(tab: Tab): void {
    if (this.activeTab === tab) return;
    const path = tab === 'subscriptions' ? 'order-subscription' : 'orders';
    this.router.navigateByUrl(`/dashboard/${path}`);
  }

  private resolveTabFromUrl(url: string): Tab {
    return url.includes('/dashboard/order-subscription')
      ? 'subscriptions'
      : 'orders';
  }
}
